import * as React from 'react';
import * as ReactQuill from 'react-quill';
import { Views } from '../../../abstract';
import { Constants, ProjectViews } from '../../abstract';

interface IDashboardConclusionAddEditViewProps extends Interfaces.IViewProps {
    onSave: () => void
}

class DashboardConclusionAddEditView<P, S> extends ProjectViews.CommonView<P & IDashboardConclusionAddEditViewProps, S> {

    constructor(props: any) {
        super(props);
    }

    public validateForm() {
        const { onSave } = this.props;
        const { model } = this.state;
        if (model['name']) {
            if (model['content'].ru && model['content'].en) {
                onSave();
            } else {
                this.setState({ error: 'Заполните контент ПостУТП на обоих языках!' })
            }
        } else {
            this.setState({ error: 'Заполните наименование ПостУТП!' })
        }
    }

    public renderFullWidthSide() {
        const { model, languageTabValue } = this.state;
        return (
            <React.Fragment>
                <Views.TextField
                    floatingLabelText="Наименование"
                    fullWidth={true}                    
                    data-field-type="nml"
                    name="name"
                    value={model['name'] ? model['name'] : ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <ReactQuill
                    modules={{
                        syntax: true,
                        clipboard: {
                            matchVisual: false,
                        },
                        toolbar: Constants.QuillEditorConstants.toolbarOptions
                    }}
                    placeholder="Контент ПостУТП"
                    onChange={(v) => this.onTextChange(v, 'content')}
                    className="editor-view"
                    value={model['content'][languageTabValue] || ''}
                />
            </React.Fragment>
        )
    }
}

export default DashboardConclusionAddEditView;



// WEBPACK FOOTER //
// ./src/app/dashboard/conclusion/addedit/ConclusionAddEditView.tsx